import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LicenseOverrideType } from '../../models/license-override-list.model';

@Component({
  selector: 'ms-license-override-tag',
  templateUrl: './license-override-tag.component.html',
  styleUrls: ['./license-override-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LicenseOverrideTagComponent {
  @Input() public overrideType: LicenseOverrideType | null = null;

  public get label(): string {
    switch (this.overrideType) {
      case 'IN_ORDER':
        return 'By-pass';
      case 'GRACE_PERIOD':
        return 'Avertissement';
      case 'READ_ONLY':
        return 'Lecture seule';
      case 'NOT_VALID':
        return 'Bloqué';
      default:
        return '';
    }
  }

  public get isVisible(): boolean {
    return this.label.length > 0;
  }

  public get badgeClass(): string {
    switch (this.overrideType) {
      case 'IN_ORDER':
        return 'override-tag--green';
      case 'GRACE_PERIOD':
        return 'override-tag--orange';
      case 'READ_ONLY':
      case 'NOT_VALID':
        return 'override-tag--red';
      default:
        return '';
    }
  }
}
